export enum DeheadingRateBasedEnum{
    HL = "HL",
    HON = "HON"
}